export default __webpack_public_path__ + "static/media/application-settings.5ffde905.svg";